import React from 'react';
import { Button } from 'react-bootstrap';
import EditVerificationForm from './EditVerificationForm';
import { getVerificationById } from './api';
import { useQuery } from '@apollo/client';
import Navbar from '../Navbar';

export const TransferredItemsForm = (props: any) => {
  const { loading, error, data } = useQuery(getVerificationById, {
    variables: { verifyId: parseFloat(props.match.params.id) },
  });

  if (loading)
    return (
      <Button variant='primary'>
        <i className='fa fa-edit'></i>
      </Button>
    );
  if (error) return <div>error</div>;

  if (data) {
    return (
      <div>
        <Navbar />
        <div className='m-5'>
          <EditVerificationForm data={data.verificationById} queryData={data} disableFields={false} toTransfer={true} />
        </div>
      </div>
    );
  }
};
